<template>
    <div class="container"></div>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        agent_info: Object,
        agent_user_id: Number,
        csrf_token: String,
        api_token: String,
        current_date: String,
        nextDate: String,
    },
    data() {
        return {
            memberOptionList: [],
            pendingMemberUserId: null,

            agentID: null,
            scheduleID: null,
            memberID: null,
            tutorID: null,
            scheduled_at: null,

            accounts: [],
            multiAccountID: null,
            showMultiAccountDropdown: false,
        };
    },
    mounted() {
        this.agentID = this.$props.agent_info.user_id;
        this.getAgentMemberList();
    },
    methods: {
        hasSwal() {
            return typeof Swal !== 'undefined' && Swal && typeof Swal.fire === 'function';
        },
        escapeHtml(text) {
            const div = document.createElement('div');
            div.textContent = text == null ? '' : String(text);
            return div.innerHTML;
        },
        swalConfirm(text, icon) {
            if (!this.hasSwal()) {
                return Promise.resolve({ isConfirmed: confirm(text) });
            }

            return Swal.fire({
                title: '確認',
                text: text,
                icon: icon || 'question',
                showCancelButton: true,
                confirmButtonText: 'はい',
                cancelButtonText: 'いいえ',
            });
        },
        swalAlert(text, icon) {
            if (!this.hasSwal()) {
                alert(text);
                return Promise.resolve();
            }

            return Swal.fire({
                title: icon === 'error' ? 'エラー' : 'お知らせ',
                text: text,
                icon: icon || 'info',
                confirmButtonText: '閉じる',
            });
        },
        buildMemberOptionsHtml(defaultMemberId) {
            let html = '<option value="">-- 受講生を選択 --</option>';
            const members = Object.values(this.memberOptionList || {});

            members.forEach((member) => {
                const selected = String(member.id) === String(defaultMemberId) ? ' selected' : '';
                html += `<option value="${member.id}"${selected}>${this.escapeHtml(member.name)}</option>`;
            });

            return html;
        },
        buildAccountOptionsHtml(accounts) {
            let html = '';

            (accounts || []).forEach((account) => {
                const id = account.member_multi_account_id;
                const label = `AC${id} - ${account.name}`;
                const selected = (account.is_default === true || account.is_default === 1 || account.is_default === 'true')
                    ? ' selected'
                    : '';
                html += `<option value="${id}"${selected}>${this.escapeHtml(label)}</option>`;
            });

            return html;
        },
        buildBookingSwalHtml(defaultMemberId) {
            return ''
                + '<div class="form-group text-left mb-2">'
                + '<label for="swal-agent-member" class="small font-weight-bold d-block mb-1">受講生</label>'
                + `<select id="swal-agent-member" class="form-control form-control-sm">${this.buildMemberOptionsHtml(defaultMemberId)}</select>`
                + '</div>'
                + '<div id="swal-agent-account-wrap" class="form-group text-left mb-0" style="display:none">'
                + '<label for="swal-agent-account" class="small font-weight-bold d-block mb-1">受講生アカウント</label>'
                + '<select id="swal-agent-account" class="form-control form-control-sm"></select>'
                + '</div>';
        },
        updateAccountSelectInSwal(accounts) {
            const wrap = document.getElementById('swal-agent-account-wrap');
            const select = document.getElementById('swal-agent-account');

            if (!wrap || !select) {
                return;
            }

            if (!accounts || accounts.length === 0) {
                wrap.style.display = 'none';
                select.innerHTML = '';
                this.showMultiAccountDropdown = false;
                this.multiAccountID = null;
                return;
            }

            wrap.style.display = 'block';
            this.showMultiAccountDropdown = true;
            this.accounts = accounts;
            select.innerHTML = this.buildAccountOptionsHtml(accounts);

            const defaultAccount = accounts.find(
                (account) => account.is_default === true || account.is_default === 1 || account.is_default === 'true'
            );
            this.multiAccountID = defaultAccount
                ? defaultAccount.member_multi_account_id
                : accounts[0].member_multi_account_id;
        },
        loadAccountsForSwalMember(memberId) {
            if (!memberId) {
                this.updateAccountSelectInSwal([]);
                return Promise.resolve([]);
            }

            return axios.post('/api/getMultiAccountOptions?api_token=' + this.api_token, {
                method: 'POST',
                memberID: memberId,
            }).then((response) => {
                const accounts = response.data.accounts || [];
                this.updateAccountSelectInSwal(accounts);
                return accounts;
            }).catch(() => {
                this.updateAccountSelectInSwal([]);
                return [];
            });
        },
        showSwalMemberBookingDialog() {
            if (!this.hasSwal()) {
                this.swalAlert('SweetAlert が読み込まれていません', 'error');
                return;
            }

            const defaultMemberId = this.pendingMemberUserId || '';
            const vm = this;

            Swal.fire({
                title: 'レッスン予約',
                html: this.buildBookingSwalHtml(defaultMemberId),
                showCancelButton: true,
                confirmButtonText: '予約する',
                cancelButtonText: 'キャンセル',
                focusConfirm: false,
                width: '32rem',
                didOpen: () => {
                    const memberEl = document.getElementById('swal-agent-member');
                    if (!memberEl) {
                        return;
                    }

                    const onMemberChange = () => {
                        const memberId = memberEl.value;
                        vm.memberID = memberId || null;
                        vm.loadAccountsForSwalMember(memberId);
                    };

                    memberEl.addEventListener('change', onMemberChange);

                    if (defaultMemberId) {
                        memberEl.value = String(defaultMemberId);
                        onMemberChange();
                    }
                },
                preConfirm: () => {
                    const memberEl = document.getElementById('swal-agent-member');
                    const accountEl = document.getElementById('swal-agent-account');
                    const accountWrap = document.getElementById('swal-agent-account-wrap');
                    const memberId = memberEl ? memberEl.value : '';

                    if (!memberId) {
                        Swal.showValidationMessage('受講生を選択してください');
                        return false;
                    }

                    const needsAccount = accountWrap && accountWrap.style.display !== 'none';
                    let multiAccountId = null;

                    if (needsAccount) {
                        multiAccountId = accountEl ? accountEl.value : '';
                        if (!multiAccountId) {
                            Swal.showValidationMessage('受講生アカウントを選択してください');
                            return false;
                        }
                    }

                    return { memberId, multiAccountId };
                },
            }).then((result) => {
                if (!result || !result.isConfirmed || !result.value) {
                    return;
                }

                this.memberID = result.value.memberId;
                this.multiAccountID = result.value.multiAccountId;
                this.pendingMemberUserId = null;
                this.runBookConfirmationFlow();
            });
        },
        reservationDate() {
            if (!this.scheduled_at) {
                return null;
            }

            return moment(this.scheduled_at).format('YYYY-MM-DD');
        },
        setPendingMemberUserId(userId) {
            this.pendingMemberUserId = userId ? userId : null;
        },
        ensureMemberListLoaded() {
            const options = Object.values(this.memberOptionList || {});
            if (options.length > 0) {
                return Promise.resolve();
            }

            return this.getAgentMemberList();
        },
        getAgentMemberList() {
            return axios.post('/api/getAgentMembers?api_token=' + this.api_token, {
                method: 'POST',
                message: '',
                agent_user_id: this.$props.agent_user_id,
            }).then((response) => {
                const options = [];

                if (response.data.success === true) {
                    response.data.members.forEach((member) => {
                        options[member.uid] = {
                            id: member.uid,
                            firstname: member.fn,
                            lastname: member.ln,
                            name: member.uid + ' ' + member.fn + ' ' + member.ln,
                        };
                    });
                }

                this.memberOptionList = options;
                return options;
            });
        },
        openSelectMemberModal(tutor, schedule) {
            this.tutorID = tutor.user_id;
            this.scheduleID = schedule.id;
            this.multiAccountID = schedule.maid || null;
            this.scheduled_at = schedule.scheduled_at;
            this.memberID = null;
            this.accounts = [];
            this.showMultiAccountDropdown = false;

            const openDialog = () => {
                this.showSwalMemberBookingDialog();
            };

            if (Object.values(this.memberOptionList || {}).length === 0) {
                this.getAgentMemberList().then(openDialog);
            } else {
                openDialog();
            }
        },
        openCancelBookingConfirmationModal(tutor, schedule) {
            this.tutorID = tutor.user_id;
            this.scheduleID = schedule.id;

            axios.post('/api/getScheduleDetails?api_token=' + this.api_token, {
                method: 'POST',
                ScheduleItemID: this.scheduleID,
                memberID: schedule.member_id,
            }).then((response) => {
                let message = 'このレッスンをキャンセルしてもいいですか？';
                let icon = 'warning';

                if (response.data.success === false) {
                    message = response.data.message_jp || response.data.message || message;
                } else if (response.data.schedule_status === 'CLIENT_RESERVED_B') {
                    message = 'こちらの予約はキャンセルができませんがよろしいでしょうか？';
                } else if (response.data.schedule_status === 'CLIENT_RESERVED') {
                    message = 'このレッスンをキャンセルしてもいいですか？';
                }

                return this.swalConfirm(message, icon);
            }).then((result) => {
                if (result && result.isConfirmed) {
                    this.cancelSchedule();
                }
            }).catch(() => {
                this.swalAlert('予約情報の取得に失敗しました', 'error');
            });
        },
        runBookConfirmationFlow() {
            const reservationDate = this.reservationDate();

            if (!reservationDate) {
                this.confirmAndBook('予約してもいいですか？');
                return;
            }

            this.$emit('call-open-loading-modal', '予約内容を確認しています...');

            axios.post('/api/getTotalTutorDailyReserved?api_token=' + this.api_token, {
                method: 'POST',
                memberID: this.memberID,
                tutorID: this.tutorID,
                date: reservationDate,
            }).then((response) => {
                this.$emit('call-close-loading-modal');

                const data = response.data || {};

                if (data.success !== true) {
                    this.swalAlert(data.message_jp || data.message || '予約の確認に失敗しました', 'error');
                    return;
                }

                if (data.totalMemberReserved >= 15) {
                    this.swalAlert('予約数が上限に達したため予約できません', 'warning');
                    return;
                }

                if (data.totalTutorDailyReserved < 2) {
                    this.confirmAndBook('予約してもいいですか？');
                    return;
                }

                this.confirmAndBook('同日、同講師の予約上限2コマを超えています。こちらの予約はキャンセルができませんがよろしいでしょうか？');
            }).catch(() => {
                this.$emit('call-close-loading-modal');
                this.confirmAndBook('予約してもいいですか？');
            });
        },
        confirmAndBook(message) {
            this.swalConfirm(message, 'question').then((result) => {
                if (result && result.isConfirmed) {
                    this.executeBookSchedule();
                }
            });
        },
        executeBookSchedule() {
            this.$emit('call-open-loading-modal', 'レッスン予約を処理しています...');

            axios.post('/api/book?api_token=' + this.api_token, {
                method: 'POST',
                date: this.scheduled_at,
                memberID: this.memberID,
                memberMultiAccountID: this.multiAccountID,
                tutorID: this.tutorID,
                scheduleID: this.scheduleID,
            }).then((response) => {
                this.$emit('call-close-loading-modal');

                if (response.data.success === true) {
                    this.$emit('call-open-loading-modal', 'レッスン予約が完了しました');

                    setTimeout(() => {
                        this.$emit('call-close-loading-modal');
                        this.callParentRefreshCalendar();
                    }, 1000);
                } else {
                    this.swalAlert(
                        response.data.message_jp || response.data.message || response.data.message_en || '予約に失敗しました',
                        'error'
                    );
                }
            }).catch(() => {
                this.$emit('call-close-loading-modal');
                this.swalAlert('予約に失敗しました', 'error');
            });
        },
        cancelSchedule() {
            this.$emit('call-open-loading-modal', '予約キャンセルを処理しています...');

            axios.post('/api/cancelSchedule?api_token=' + this.api_token, {
                method: 'POST',
                id: this.scheduleID,
                agentID: this.agentID,
                tutorID: this.tutorID,
            }).then((response) => {
                this.$emit('call-close-loading-modal');

                if (response.data.success === true) {
                    this.$emit('call-open-loading-modal', '予約をキャンセルしました');

                    setTimeout(() => {
                        this.$emit('call-close-loading-modal');
                        this.callParentRefreshCalendar();
                    }, 1000);
                } else {
                    this.swalAlert(
                        response.data.message_jp || response.data.message || response.data.message_en || 'キャンセルに失敗しました',
                        'error'
                    );
                }
            }).catch(() => {
                this.$emit('call-close-loading-modal');
                this.swalAlert('キャンセルに失敗しました', 'error');
            });
        },
        callParentRefreshCalendar() {
            this.$emit('call-refresh-calender');
        },
    },
};
</script>

<style scoped>
.swal2-html-container .form-control {
    width: 100%;
}
</style>
